import { LitElement, html, svg } from 'lit';

export class IconBookmark16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Bokmerke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 1h11a1 1 0 0 1 1 1v13l-5.89-4.531a1 1 0 0 0-1.22 0L1.5 15V2a1 1 0 0 1 1-1Z"></path></svg>`; }
}
if (!customElements.get('f-icon-bookmark16', IconBookmark16)) {
  customElements.define('f-icon-bookmark16', IconBookmark16);
}